import DateTimeHelper from "shared/utils/dateTimeHelper";

//user can select this much year before and after current date.
export const YEAR_SELECTOR_RANGE = 100;

export function getMonthNames() {
  return Array.from({ length: 12 }, (_, index) => {
    const month = index + 1;
    return DateTimeHelper.getMonthByMonthName(month);
  });
}
